// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i4VH","left":"styles_left__2vZ62"};